// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import TimeSlotController from "./time_slot_controller"
application.register("time-slot", TimeSlotController)

import TimePickerController from "./time_picker_controller"
application.register("time-picker", TimePickerController)

import BookingFeeController from "./booking_fee_controller"
application.register("booking-fee", BookingFeeController)
